"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORE = exports.pageTypes = void 0;
exports.pageTypes = [
    'home',
    'search',
    'favorites',
    'trending',
    'landing-page',
    'your-tech',
    'sub-category',
    'how-it-works',
    'category',
    'deals',
    'pdp',
    'others',
    'referrals',
    'referred',
    'your-profile',
    'your-payments',
    'for-business',
    'g-explore',
    'for-you',
];
var STORE;
(function (STORE) {
    STORE["DE"] = "de";
    STORE["NL"] = "nl";
    STORE["ES"] = "es";
    STORE["AT"] = "at";
    STORE["US"] = "us";
    STORE["BUSINESS"] = "business";
    STORE["BUSINESS_NL"] = "business_nl";
    STORE["BUSINESS_ES"] = "business_es";
    STORE["BUSINESS_AT"] = "business_at";
    STORE["BUSINESS_US"] = "business_us";
})(STORE = exports.STORE || (exports.STORE = {}));
//# sourceMappingURL=constants.js.map